export default {
  install(Vue) {
    Vue.prototype.$alert = function (title, type) {
      return this.$root.$emit("alert", { title, type });
    };
  },
};
